import React from 'react';
import { Clock } from 'lucide-react';

const TAG_STYLES = {
  'Canine': 'bg-[#BEDBFF] text-[#1447E6] border-[#BEDBFF]',
  'Feline': 'bg-[#BEDBFF] text-[#1447E6] border-[#BEDBFF]',
  'Multi-Species': 'bg-[#BEDBFF] text-[#1447E6] border-[#BEDBFF]',
  'Surgical': 'bg-[#E9D4FF] text-[#8200DB] border-[#E9D4FF]',
  'Surgical Case': 'bg-[#E9D4FF] text-[#8200DB] border-[#E9D4FF]',
  'Emergency': 'bg-[#FEE2E2] text-[#DC2626] border-[#FEE2E2]',
  'Emergency Case': 'bg-[#FEE2E2] text-[#DC2626] border-[#FEE2E2]',
  'Diagnostic Challenge': 'bg-[#E9D4FF] text-[#8200DB] border-[#E9D4FF]',
  'Clinical Essentials': 'bg-[#E9D4FF] text-[#8200DB] border-[#E9D4FF]',
  'Pathology': 'bg-[#FEF3C7] text-[#D97706] border-[#FEF3C7]',
  'Dermatology': 'bg-[#FCE7F3] text-[#BE185D] border-[#FCE7F3]',
  'General': 'bg-[#E0E7FF] text-[#4F46E5] border-[#E0E7FF]',
  'Ask and Learn': 'bg-[#D1FAE5] text-[#059669] border-[#D1FAE5]',
};

const CaseHeader = ({ author, specialty, jobRole, timeAgo, tags = [], avatarUrl, isRestricted }) => {
  const initials = author
    .replace('Dr. ', '')
    .split(' ')
    .map(w => w[0])
    .join('')
    .toUpperCase();

  const displayRole = jobRole || specialty || 'Veterinarian';

  return (
    <div className="flex items-start gap-3">
      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-accent-indigo/20 to-accent-blue/20 
                      flex items-center justify-center text-xs font-bold text-accent-indigo flex-shrink-0 overflow-hidden">
        {avatarUrl ? (
          <img src={avatarUrl} alt={author} className="w-full h-full object-cover" />
        ) : (
          initials
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-text-black">{author}</span>
          <span className="text-light-gray text-sm">•</span>
          <span className="text-sm font-medium text-indigo-600">{displayRole}</span>
        </div>
        <div className="flex items-center gap-2 mt-1 flex-wrap">
          <div className="flex items-center gap-1 text-light-gray">
            <Clock size={12} />
            <span className="text-xs">{timeAgo}</span>
          </div>
          {tags.map((tag) => (
            <span
              key={tag}
              className={`text-xs px-2 py-0.5 rounded-full border font-medium
                         ${TAG_STYLES[tag] || 'bg-gray-50 text-gray-600 border-gray-200'}`}
            >
              {tag}
            </span>
          ))}
          {isRestricted && (
            <span className="text-xs px-2.5 py-0.5 rounded-full border font-semibold bg-amber-50 text-amber-700 border-amber-200">
              🔒 Private
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseHeader;